<div class="w-full flex flex-col gap-1">
  <p class="text-color-secondary p-0 m-0">{{ title }}</p>
  @if (isLoading) {
    <palantir-skeleton class="w-full h-5 rounded-lg"></palantir-skeleton>
  }
  @if (!isLoading) {
    <p class="text-color-normal p-0 m-0 break-words">{{ value || '-' }}</p>
  }
</div>
